export enum PropertyCatalogItemsMoveTo {
    CATALOG = 'catalog',
    ORDER = 'order',
    INVENTORY = 'inventory',
    VIEW_ONLY = 'view_only',
}
